import { CustomError } from './customError';

export class S3NetworkError extends CustomError { }
